export interface BodyMapPanel {
  src: string;
  w: number;
  h: number;
}

export const BODY_MAP_PANELS: Record<string, BodyMapPanel> = {
  tubuh_belakang_depan: {
    w: 1000,
    h: 624,
    src: require("@/assets/marker-site/tubuh_belakang_depan.png")
  },
  pria_anterior: {
    w: 191,
    h: 640,
    src: require("@/assets/marker-site/pria_anterior.png")
  },
  pria_posterior: {
    w: 190,
    h: 640,
    src: require("@/assets/marker-site/pria_posterior.png")
  },
  wanita_anterior: {
    w: 180,
    h: 640,
    src: require("@/assets/marker-site/wanita_anterior.png")
  },
  wanita_posterior: {
    w: 199,
    h: 640,
    src: require("@/assets/marker-site/wanita_posterior.png")
  },
  kepala_lateral_kiri: {
    w: 438,
    h: 640,
    src: require("@/assets/marker-site/kepala_lateral_kiri.png")
  },
  kepala_lateral_kanan: {
    w: 438,
    h: 640,
    src: require("@/assets/marker-site/kepala_lateral_kanan.png")
  },
  wajah_anterior: {
    w: 504,
    h: 640,
    src: require("@/assets/marker-site/wajah_anterior.png")
  },
  kepala_posterior: {
    w: 508,
    h: 640,
    src: require("@/assets/marker-site/kepala_posterior.png")
  },
  tangan_palmar_kiri: {
    w: 469,
    h: 640,
    src: require("@/assets/marker-site/tangan_palmar_kiri.png")
  },
  tangan_palmar_kanan: {
    w: 462,
    h: 640,
    src: require("@/assets/marker-site/tangan_palmar_kanan.png")
  },
  tangan_dorsal_kiri: {
    w: 401,
    h: 640,
    src: require("@/assets/marker-site/tangan_dorsal_kiri.png")
  },
  tangan_dorsal_kanan: {
    w: 406,
    h: 640,
    src: require("@/assets/marker-site/tangan_dorsal_kanan.png")
  },
  kaki_plantar_kiri: {
    w: 330,
    h: 640,
    src: require("@/assets/marker-site/kaki_plantar_kiri.png")
  },
  kaki_plantar_kanan: {
    w: 332,
    h: 640,
    src: require("@/assets/marker-site/kaki_plantar_kanan.png")
  },
  kaki_dorsal_kiri: {
    w: 282,
    h: 640,
    src: require("@/assets/marker-site/kaki_dorsal_kiri.png")
  },
  kaki_dorsal_kanan: {
    w: 354,
    h: 640,
    src: require("@/assets/marker-site/kaki_dorsal_kanan.png")
  },
  traktus_urinarius: {
    w: 259,
    h: 640,
    src: require("@/assets/marker-site/traktus_urinarius.png")
  },
  genitalia_pria: {
    w: 432,
    h: 257,
    src: require("@/assets/marker-site/genitalia_pria.png")
  },
  odontogram_anak_atas: {
    w: 640,
    h: 452,
    src: require("@/assets/marker-site/odontogram_anak_atas.png")
  },
  odontogram_anak_bawah: {
    w: 640,
    h: 452,
    src: require("@/assets/marker-site/odontogram_anak_bawah.png")
  },
  odontogram_dewasa_atas: {
    w: 640,
    h: 431,
    src: require("@/assets/marker-site/odontogram_dewasa_atas.png")
  },
  odontogram_dewasa_bawah: {
    w: 640,
    h: 514,
    src: require("@/assets/marker-site/odontogram_dewasa_bawah.png")
  }
};
